module.exports = __webpack_public_path__ + "static/media/features.b084a3be.png";